import Layout from "../Layout/Layout";
import Script from "../../components/Script/Script";
import "./Contact.css";

const Contact = () => {
  return (
    <Layout>
      <Script src="https://js-na2.hsforms.net/forms/embed/243839670.js" defer />

      <div
        className={`bg-white rounded-3xl shadow-xl overflow-hidden flex flex-col md:flex-row m-10`}
      >
        <div className="flex flex-row w-full p-10">
          <div className="hidden md:block">
            <img
              src="/images/earthboundmartian-landships-full-color-rgb-drill.png"
              alt="Marty"
              id="contactImage"
              className="w-full h-full object-cover"
            />
          </div>
          <div
            id="contactUsForm"
            className="hs-form-frame flex-1"
            data-region="na2"
            data-form-id="db68ea3f-1b6b-435b-9144-e75afa355056"
            data-portal-id="243839670"
          ></div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
